<template lang="pug">
  tr.row
    td.col.check(v-if="false")
      label.checkbox
        input(
          type="checkbox",
          :value="startingBusiness.id",
          :checked='checked',
          :disabled="isGlobalLocked",
          @click="check($event, startingBusiness.id)"
        )
    td.col(class="company_name")
      span.new(v-if="startingBusiness.is_new") NEW
      a(@click="display") {{ startingBusiness['facility_name'] }}
    td.col(class="campany_tel")
      span {{ startingBusiness['genre'] }}
    td.col(class="campany_tel")
      span {{ startingBusiness['phone_number'] }}
    td.col(class="sales_status")
      span {{ startingBusiness['sales_status'] }}
    td.col(class="assigned_to")
      span {{ startingBusiness['assigned_to'] }}
    td.col(class="created_at")
      span {{ startingBusiness['created_at'] }}
    td.col(class="updated_at")
      span {{ startingBusiness['updated_at'] }}
    td.col
      a(class="button-delete" @click="removeStartingBusinessList(startingBusiness.id)")
        i.fas.fa-trash-alt
        |  削除
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    props: ['startingBusiness', 'modal', 'checkedIds'],
    computed: {
      ...mapGetters('common', ['isGlobalLocked']),
      checked () {
        return this.checkedIds.has(this.startingBusiness.id)
      },
    },
    methods: {
      ...mapMutations('startingBusiness', ['clearDetail']),
      check (event, id) {
        event.preventDefault()
        const checked = event.currentTarget.checked
        this.$emit('check', { checked, id })
      },
      display (e) {
        e.stopPropagation()
        this.$emit('display', { id: this.startingBusiness.id })
      },
      update () {
        this.clearDetail()
        this.$emit('update', { id: this.startingBusiness.id })
      },
      async removeStartingBusinessList (id) {
        // eslint-disable-next-line no-alert
        if (confirm('本当に削除しますか？')) {
          this.$store.commit('common/lockGlobal')
          try {
            await this.$store.dispatch('startingBusinessList/remove', { id })
            this.$store.commit('common/unlockGlobal')
            this.$emit('update', { id })
          } catch (e) {
            this.$store.commit('common/unlockGlobal')
          }
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/StartingBusinessListTableRow.vue